import PageLayout from "@/pages/home/components/PageLayout";
import AboutSection from "@/pages/home/components/AboutSection";

export default function AboutPage() {
  return (
    <PageLayout>
      <AboutSection />
    </PageLayout>
  );
}
